import styled from 'styled-components';

export const InfoBlockWrapper = styled.div`
  display: flex;
  gap: 25px 10px;
  flex-wrap: wrap;
`;
